import { render, staticRenderFns } from "./LocalSvgIcon.vue?vue&type=template&id=b1398a30&scoped=true"
import script from "./LocalSvgIcon.vue?vue&type=script&lang=js"
export * from "./LocalSvgIcon.vue?vue&type=script&lang=js"
import style0 from "./LocalSvgIcon.vue?vue&type=style&index=0&id=b1398a30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1398a30",
  null
  
)

export default component.exports